import { LinkAction } from '@leverege/molten/routes'

export default LinkAction.create( {
  name : 'Debug Logs', 
  id : 'boat.link.DebugLogs',
  icon : 'fa-solid fa-file',
  layout : {
    sort : 'c.91'
  },
  matches : {
    client : 'ItemScreen',
    use : 'navBar',
    objectType : 'boat',
    path : 'boat'
  },
  path : '/p/:persona/boat/:boatId/debugLogs',
} )
